/**
 * O trecho que a conferência por regras apontou (E184.F4.T03, GUS-145 item 6, ADR-0136 §5): o card
 * do pacote abre a mesa com `?trecho=` (E202.F3) e ela abre o trecho da saída que contém o texto do
 * apontamento — o texto como sai no documento (editado ou original). O apontamento vem em uma
 * linha, com o CPF mascarado e cortado no teto; a busca usa o maior pedaço sem a máscara.
 */
import type { TrechoNaTelaData } from '@/lib/correcaoDoRascunho';
import { planoDoMarkup } from '@/lib/markupDaEdicao';

/** Abaixo disso o pedaço não identifica um trecho (cairia em qualquer um). */
const MINIMO = 12;

function normal(texto: string): string {
  const plano = texto.replaceAll('⏎', ' ').replace(/…$/u, '');
  return plano.split(/\s+/u).join(' ').trim().toLocaleLowerCase('pt-BR');
}

function semMascara(texto: string): string {
  return texto
    .split('*')
    .map((pedaco) => pedaco.trim())
    .reduce((maior, pedaco) => (pedaco.length > maior.length ? pedaco : maior), '');
}

export function trechoApontado(
  trechos: readonly TrechoNaTelaData[],
  procurado: string,
): TrechoNaTelaData | null {
  const alvo = semMascara(normal(procurado));
  if (alvo.length < MINIMO) return null;
  const achado = trechos.find((trecho) => {
    // E202.F2: o texto editado tem o markup mínimo; a busca é pelo que o documento imprime.
    const texto = normal(planoDoMarkup(trecho.no_laudo ?? trecho.base ?? ''));
    return texto.includes(alvo) || (texto.length >= MINIMO && alvo.includes(texto));
  });
  return achado ?? null;
}
